module.exports = __webpack_public_path__ + "img/553.da23ebe3.gif";